// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"quotes_scrollbar__1HGJ6"};